import React from 'react';
import PdfScreen from 'shared/components/lending/PdfScreen/PdfScreen';

const TermsAndConditionsPage = () => {
  return <PdfScreen />;
};

export default TermsAndConditionsPage;
